module.exports = __webpack_public_path__ + "img/13.6dd82c34.png";